import React from 'react';
import { Badge } from './ui/badge';
import { CheckIcon } from '@heroicons/react/24/outline';

function CheckboxButton({ label, isChecked, onClick }) {
  return (
    <Badge
      onClick={onClick}
      className={`cursor-pointer select-none inline-flex items-center space-x-2 py-2 rounded-full transition-colors ${
        isChecked ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700 hover:text-white'
      }`}
    >
      <span
        className={`flex items-center justify-center w-4 h-4 border-2 rounded-full ${
          isChecked ? 'bg-white text-primary' : 'bg-gray-200 text-gray-700 border-gray-400'
        }`}
      >
        {isChecked && <CheckIcon className="w-3 h-3" />}
      </span>
      <span>{label}</span>
    </Badge>
  );
}

export default CheckboxButton;
